import { __extends } from "tslib";
import { Node } from './Node';
import { AnimationTimeline } from './AnimationTimeline';
import { Group } from '../display-objects/Group';
import { TextAlign } from '../types';
/**
 * the entry of DOM tree
 * Document -> Node -> EventTarget
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document
 */

var Document =
/** @class */
function (_super) {
  __extends(Document, _super);

  function Document() {
    var _this = _super.call(this) || this;
    /**
     * only document has defaultView, points to canvas,
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/defaultView
     */


    _this.defaultView = null;
    _this.ownerDocument = null;
    _this.nodeName = 'document'; // create timeline

    _this.timeline = new AnimationTimeline(); // like <html> in DOM tree

    _this.documentElement = new Group({
      id: 'g-root',
      style: {
        textAlign: TextAlign.START,
        fontSize: '16px',
        fontFamily: 'sans-serif' // fontStyle: 'normal',
        // fontWeight: 'normal',
        // fontVariant: 'normal',

      }
    });
    _this.documentElement.ownerDocument = _this;
    _this.documentElement.parentNode = _this;
    _this.childNodes = [_this.documentElement];
    return _this;
  }

  Object.defineProperty(Document.prototype, "children", {
    get: function get() {
      return this.childNodes;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Document.prototype, "childElementCount", {
    get: function get() {
      return this.childNodes.length;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Document.prototype, "firstElementChild", {
    get: function get() {
      return this.firstChild;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Document.prototype, "lastElementChild", {
    get: function get() {
      return this.lastChild;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * @example const circle = document.createElement('circle', { style: { r: 10 } });
   */

  Document.prototype.createElement = function (tagName, options) {
    // d3 will use <tspan>
    var clazz = this.defaultView.customElements.get(tagName);

    if (!clazz) {
      console.warn('Unsupported tagName: ', tagName);
      clazz = Group;
    }

    return new clazz(options);
  };

  Document.prototype.createElementNS = function (namespaceURI, tagName, options) {
    return this.createElement(tagName, options);
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.cloneNode = function (deep) {
    throw new Error('Method not implemented.');
  };

  Document.prototype.destroy = function () {
    try {
      this.documentElement.destroy();
    } catch (e) {}

    this.timeline.destroy();
  };
  /**
   * eg. Uncaught DOMException: Failed to execute 'appendChild' on 'Node': Only one element on document allowed.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.appendChild = function (newChild, index) {
    throw new Error('Use document.documentElement instead.');
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.insertBefore = function (newChild, refChild) {
    throw new Error('Use document.documentElement instead.');
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.removeChild = function (oldChild, destroy) {
    throw new Error('Use document.documentElement instead.');
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.replaceChild = function (newChild, oldChild, destroy) {
    throw new Error('Use document.documentElement instead.');
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.append = function () {
    var nodes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      nodes[_i] = arguments[_i];
    }

    throw new Error('Use document.documentElement instead.');
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Document.prototype.prepend = function () {
    var nodes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      nodes[_i] = arguments[_i];
    }

    throw new Error('Use document.documentElement instead.');
  };
  /**
   * Execute query on documentElement.
   */


  Document.prototype.getElementById = function (id) {
    return this.documentElement.getElementById(id);
  };

  Document.prototype.getElementsByName = function (name) {
    return this.documentElement.getElementsByName(name);
  };

  Document.prototype.getElementsByTagName = function (tagName) {
    return this.documentElement.getElementsByTagName(tagName);
  };

  Document.prototype.getElementsByClassName = function (className) {
    return this.documentElement.getElementsByClassName(className);
  };

  Document.prototype.querySelector = function (selectors) {
    return this.documentElement.querySelector(selectors);
  };

  Document.prototype.querySelectorAll = function (selectors) {
    return this.documentElement.querySelectorAll(selectors);
  };

  Document.prototype.find = function (filter) {
    return this.documentElement.find(filter);
  };

  Document.prototype.findAll = function (filter) {
    return this.documentElement.findAll(filter);
  };

  return Document;
}(Node);

export { Document };